import { useGooglePlacesAPIContext } from 'contexts';
import GoogleMapsAPI from 'integrations/GoogleMapsAPI';

export const useGooglePlacesApi = (): GoogleMapsAPI => useGooglePlacesAPIContext();
